import React, { useState } from 'react'
import Accordion from '../Accordion'
import Text from '../Text'
import ChevronDown from '../Icons/ChevronDown'

const formatVariantLabel = (variant) => {
  if (!variant) return ''
  return String(variant).replace(/(\d+)\s*(mg)/i, '$1 $2')
}

const FAQItem = ({ faq, idx }) => {
  const variants =
    faq?.answersByVariant && typeof faq.answersByVariant === 'object'
      ? Object.keys(faq.answersByVariant)
      : []
  const [selectedVariant, setSelectedVariant] = useState(variants[0] || null)

  const answer =
    selectedVariant && faq?.answersByVariant?.[selectedVariant]
      ? faq.answersByVariant[selectedVariant]
      : faq?.answer || ''

  const answerColor = faq?.answerColor ?? '#667085'
  const activeTabColor = faq?.questionColor ?? '#A44F8E'

  const answerContent =
    variants.length > 0 ? (
      <div className="overflow-hidden space-y-3">
        <div
          className="flex gap-2 p-1 bg-[#F2F4F7] rounded-full"
          role="tablist"
          aria-label="Program variant"
        >
          {variants.map((variant) => {
            const selected = variant === selectedVariant
            return (
              <button
                key={variant}
                type="button"
                role="tab"
                aria-selected={selected}
                className="flex-1 border-none bg-transparent text-[#667085] text-sm font-semibold leading-5 py-1.5 px-2 rounded-3xl cursor-pointer transition-colors"
                style={
                  selected
                    ? {
                        backgroundColor: activeTabColor,
                        color: '#ffffff',
                        boxShadow: '0 1px 2px rgba(16, 24, 40, 0.06)',
                      }
                    : undefined
                }
                onClick={() => setSelectedVariant(variant)}
              >
                {formatVariantLabel(variant)}
              </button>
            )
          })}
        </div>
        <Text
          tag="p"
          variant="body"
          size="large"
          className="overflow-hidden font-[300]"
          style={{ color: answerColor }}
          dangerouslySetInnerHTML={{ __html: answer }}
        />
      </div>
    ) : null

  return (
    <Accordion
      title={faq?.question || `FAQ ${idx + 1}`}
      answer={answer}
      answerContent={answerContent}
      index={idx}
      styles={{
        bg: '#E4F2F2',
        titleColor: faq?.questionColor ?? '#8077B7',
        answerColor,
      }}
      chevronIcon={ChevronDown}
    />
  )
}

const FAQSection = ({ data }) => {
  const title = data?.title
  const items = Array.isArray(data?.faqs) ? data.faqs : []

  return (
    <section className="w-full">
      <div className="max-w-[1024px] mx-auto px-4">
        {title ? (
          <Text
            variant="headline"
            size="small"
            tag="p"
            className="text-primary-text"
          >
            {title}
          </Text>
        ) : null}

        <div className="mt-6 space-y-3">
          {items.map((faq, idx) => (
            <FAQItem key={`sema-faq-${idx}`} faq={faq} idx={idx} />
          ))}
        </div>
      </div>
    </section>
  )
}

export default FAQSection
